import styled from '@emotion/styled';
import { Colors } from 'utils';
import device from './device';
const SectionTitleH2 = styled.div`
  h2 {
    text-align: center;
    font-size: 40px;
    color: ${Colors.black};
    display: inline-block;
    padding-bottom: 7px;
    font-weight: bold;
    @media ${device.laptop} {
      font-size: 32px;
    }
    @media ${device.allMobile} {
      text-align: center;
      font-size: 24px;
      width: 90%;
      margin: auto;
      margin-bottom: 20px;
    }
  }
`;

export default SectionTitleH2;
